import { db } from "../firebase/config";
import { addDoc, collection } from "firebase/firestore";

export async function registrarAccion(usuario, rol, modulo, accion, detalle = '', clinicaId = null) {
  try {
    await addDoc(collection(db, 'trazabilidad'), {
      usuario,
      rol,
      modulo,
      accion,
      detalle,
      clinicaId,
      fecha: new Date(),
    });
  } catch (e) {
    console.error('Error al registrar trazabilidad:', e);
  }
}